import { isEmpty } from '../../../utils'

export const dropDownTreeProps = {
  value: {
    type: String,
    default: ''
  },
  // title
  name: {
    type: String,
    default: ''
  },
  // list
  list: {
    type: Array,
    default: () => ([])
  },
  // 选项属性
  selectprops: {
    type: Object,
    default: () => {
      return {
        key: 'key',
        label: 'label',
        children: 'children'
      }
    }
  },
  // 展示样式
  showType: {
    type: String,
    default: 'simple'
  },
  // 展示完成
  showComplete: {
    type: Boolean,
    default: false
  },
  // treeProps数据
  selectedData: {
    type: Array,
    default: () => ([])
  },
  // 下拉树样式
  style: {
    type: Number,
    default: 0
  },
  // TODO selectedKeys: [],
  selectedKeys: {
    type: Array,
    default: () => {
      return []
    }
  },
  // 是否只读
  disabled: {
    type: Boolean,
    default: false
  },
  // 是否纯文本
  isPureText: {
    type: Boolean,
    default: false
  }
}

export function initValue (value) {
  return isEmpty(value) ? '-' : value
}